import { Stack, Typography } from '@mui/material'
import { FC } from 'react'

type CarrierPaymentOptionProps = {
  carrier: string
}
// キャリア決済のラジオボタン用のコンポーネント
export const CarrierPaymentOption: FC<CarrierPaymentOptionProps> = ({
  carrier,
}) => {
  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h5">{carrier}</Typography>
      </Stack>
    </Stack>
  )
}
